// All tracks from https://www.soundhelix.com/audio-examples
export const PLAYLIST_TEST = {
  title: "Test",
  tracks: [
    {
      title: "✅ Das war toll!",
      link: "/sounds/great.mp3",
      genre: "Test",
    },
    {
      title: "❎ Leider falsch!",
      link: "/sounds/tooBad.mp3",
      genre: "Test",
    },
    {
      title: "🏁 Gleich gehts los!",
      link: "/sounds/countdown.mp3",
      genre: "Test",
    },
  ],
};

export const PLAYLIST_AMBIENT = {
  title: "Ambient",
  tracks: [
    {
      title: "",
      link: "/ambient/07-flagstaff-flamenco-112412.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/audionautix-tropical-contact.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/barradeen-wish-of-being-with-you.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/love-meditation-115568.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/loving-simple-ver-111548.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/madirfan-unreleased-uplifting-guitar-demo-13-05-2021-115208.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/magical-deep-meditation-116793.mp3",
      genre: "Ambient",
    },
    {
      title: "",
      link: "/ambient/zubaida-77.mp3",
      genre: "Ambient",
    },
  ],
};

export const PLAYLIST_PIANO = {
  title: "Piano",
  tracks: [
    {
      title: "01 - NoBan Stream - Kitsune No Nageki.mp3",
      link: "/piano/01 - NoBan Stream - Kitsune No Nageki.mp3",
      genre: "Piano",
    },
    {
      title: "03 - NoBan Stream - Green Leaf.mp3",
      link: "/piano/03 - NoBan Stream - Green Leaf.mp3",
      genre: "Piano",
    },
    {
      title: "04 - NoBan Stream - Fullmoon Cocktail.mp3",
      link: "/piano/04 - NoBan Stream - Fullmoon Cocktail.mp3",
      genre: "Piano",
    },
    {
      title: "05 - NoBan Stream - Le Fil d_Ariane.mp3",
      link: "/piano/05 - NoBan Stream - Le Fil d_Ariane.mp3",
      genre: "Piano",
    },
    {
      title: "06 - NoBan Stream - In Your Eyes.mp3",
      link: "/piano/06 - NoBan Stream - In Your Eyes.mp3",
      genre: "Piano",
    },
    {
      title: "07 - NoBan Stream - Ombre Degli Occhi.mp3",
      link: "/piano/07 - NoBan Stream - Ombre Degli Occhi.mp3",
      genre: "Piano",
    },
    {
      title: "08 - NoBan Stream - Jimbo.mp3",
      link: "/piano/08 - NoBan Stream - Jimbo.mp3",
      genre: "Piano",
    },
    {
      title: "09 - NoBan Stream - Love To Remember.mp3",
      link: "/piano/09 - NoBan Stream - Love To Remember.mp3",
      genre: "Piano",
    },
    {
      title: "10 - NoBan Stream - A Spirit Within.mp3",
      link: "/piano/10 - NoBan Stream - A Spirit Within.mp3",
      genre: "Piano",
    },
    {
      title: "11 - NoBan Stream - All A Lie.mp3",
      link: "/piano/11 - NoBan Stream - All A Lie.mp3",
      genre: "Piano",
    },
    {
      title: "12 - NoBan Stream - Makanu.mp3",
      link: "/piano/12 - NoBan Stream - Makanu.mp3",
      genre: "Piano",
    },
    {
      title: "13 - NoBan Stream - Masked Man.mp3",
      link: "/piano/13 - NoBan Stream - Masked Man.mp3",
      genre: "Piano",
    },
    {
      title: "14 - NoBan Stream - To Roots.mp3",
      link: "/piano/14 - NoBan Stream - To Roots.mp3",
      genre: "Piano",
    },
    {
      title: "15 - NoBan Stream - Sem Lamentos.mp3",
      link: "/piano/15 - NoBan Stream - Sem Lamentos.mp3",
      genre: "Piano",
    },
    {
      title: "16 - NoBan Stream - Celebrate Again.mp3",
      link: "/piano/16 - NoBan Stream - Celebrate Again.mp3",
      genre: "Piano",
    },
    {
      title: "17 - NoBan Stream - Carousel Of Hope.mp3",
      link: "/piano/17 - NoBan Stream - Carousel Of Hope.mp3",
      genre: "Piano",
    },
    {
      title: "18 - NoBan Stream - True Heart.mp3",
      link: "/piano/18 - NoBan Stream - True Heart.mp3",
      genre: "Piano",
    },
    {
      title: "19 - NoBan Stream - Cardboard Paper.mp3",
      link: "/piano/19 - NoBan Stream - Cardboard Paper.mp3",
      genre: "Piano",
    },
    {
      title: "20 - NoBan Stream - Adijo Kit.mp3",
      link: "/piano/20 - NoBan Stream - Adijo Kit.mp3",
      genre: "Piano",
    },
  ],
};

export const PLAYLIST_SYNTHWAVE = {
  title: "Synthwave",
  tracks: [
    {
      title: "06 - NoBan Stream - Beaming Club.mp3",
      link: "/synthwave/06 - NoBan Stream - Beaming Club.mp3",
      genre: "Synthwave",
    },
    {
      title: "07 - NoBan Stream - Arcade Motoki.mp3",
      link: "/synthwave/07 - NoBan Stream - Arcade Motoki.mp3",
      genre: "Synthwave",
    },
    {
      title: "09 - NoBan Stream - Bonjour Kaname.mp3",
      link: "/synthwave/09 - NoBan Stream - Bonjour Kaname.mp3",
      genre: "Synthwave",
    },
    {
      title: "11 - NoBan Stream - Radiant Bonbon.mp3",
      link: "/synthwave/11 - NoBan Stream - Radiant Bonbon.mp3",
      genre: "Synthwave",
    },
    {
      title: "12 - NoBan Stream - You Me _ Fabienne.mp3",
      link: "/synthwave/12 - NoBan Stream - You Me _ Fabienne.mp3",
      genre: "Synthwave",
    },
    {
      title: "15 - NoBan Stream - Oyasumi Princess.mp3",
      link: "/synthwave/15 - NoBan Stream - Oyasumi Princess.mp3",
      genre: "Synthwave",
    },
    {
      title: "17 - NoBan Stream - Cosmo Club.mp3",
      link: "/synthwave/17 - NoBan Stream - Cosmo Club.mp3",
      genre: "Synthwave",
    },
    {
      title: "18 - NoBan Stream - International Drive 85.mp3",
      link: "/synthwave/18 - NoBan Stream - International Drive 85.mp3",
      genre: "Synthwave",
    },
    {
      title: "19 - NoBan Stream - Journey To Kaio.mp3",
      link: "/synthwave/19 - NoBan Stream - Journey To Kaio.mp3",
      genre: "Synthwave",
    },
  ],
};

export const PLAYLIST_GAMING = {
  title: "Gaming",
  tracks: [
    {
      title: "01 - NoBan Stream - Not A Noob.mp3",
      link: "/gaming/01 - NoBan Stream - Not A Noob.mp3",
      genre: "Gaming",
    },
    {
      title: "02 - NoBan Stream - Not Yet A Hero.mp3",
      link: "/gaming/02 - NoBan Stream - Not Yet A Hero.mp3",
      genre: "Gaming",
    },
    {
      title: "03 - NoBan Stream - Teach Me Sensei.mp3",
      link: "/gaming/03 - NoBan Stream - Teach Me Sensei.mp3",
      genre: "Gaming",
    },
    {
      title: "04 - NoBan Stream - Dummy Training.mp3",
      link: "/gaming/04 - NoBan Stream - Dummy Training.mp3",
      genre: "Gaming",
    },
    {
      title: "05 - NoBan Stream - PKK.mp3",
      link: "/gaming/05 - NoBan Stream - PKK.mp3",
      genre: "Gaming",
    },
    {
      title: "06 - NoBan Stream - Bards Just Wanna Have Friends.mp3",
      link: "/gaming/06 - NoBan Stream - Bards Just Wanna Have Friends.mp3",
      genre: "Gaming",
    },
    {
      title: "07 - NoBan Stream - Mushroom Cavern.mp3",
      link: "/gaming/07 - NoBan Stream - Mushroom Cavern.mp3",
      genre: "Gaming",
    },
    {
      title: "08 - NoBan Stream - CD UP!.mp3",
      link: "/gaming/08 - NoBan Stream - CD UP!.mp3",
      genre: "Gaming",
    },
    {
      title: "09 - NoBan Stream - Full Burst.mp3",
      link: "/gaming/09 - NoBan Stream - Full Burst.mp3",
      genre: "Gaming",
    },
    {
      title: "10 - NoBan Stream - Route 02.mp3",
      link: "/gaming/10 - NoBan Stream - Route 02.mp3",
      genre: "Gaming",
    },
    {
      title: "11 - NoBan Stream - Forever Town.mp3",
      link: "/gaming/11 - NoBan Stream - Forever Town.mp3",
      genre: "Gaming",
    },
    {
      title: "12 - NoBan Stream - Nighttime Chronicles.mp3",
      link: "/gaming/12 - NoBan Stream - Nighttime Chronicles.mp3",
      genre: "Gaming",
    },
    {
      title: "13 - NoBan Stream - Golden Vault.mp3",
      link: "/gaming/13 - NoBan Stream - Golden Vault.mp3",
      genre: "Gaming",
    },
    {
      title: "14 - NoBan Stream - Ignited.mp3",
      link: "/gaming/14 - NoBan Stream - Ignited.mp3",
      genre: "Gaming",
    },
    {
      title: "15 - NoBan Stream - Army of Five.mp3",
      link: "/gaming/15 - NoBan Stream - Army of Five.mp3",
      genre: "Gaming",
    },
    {
      title: "16 - NoBan Stream - Telegraph-Open-High.mp3",
      link: "/gaming/16 - NoBan Stream - Telegraph-Open-High.mp3",
      genre: "Gaming",
    },
    {
      title: "17 - NoBan Stream - Wipe Is Not An Option-Open-High.mp3",
      link: "/gaming/17 - NoBan Stream - Wipe Is Not An Option-Open-High.mp3",
      genre: "Gaming",
    },
    {
      title: "18 - NoBan Stream - Switch It Up.mp3",
      link: "/gaming/18 - NoBan Stream - Switch It Up.mp3",
      genre: "Gaming",
    },
  ],
};
